import { type FC, useState } from 'react';
import { Badge } from 'react-bootstrap';
import { BsArrowRight, BsCaretDownFill } from 'react-icons/bs';

import { NewBadge } from '@editor2/components/Badge';
import { type Chapter } from '@editor2/types/chapter';
import { type PageGroup } from '@editor2/types/pageGroup';
import { chapterChangesStyle, headerStyle } from '../styles';
import { type Page } from '@editor2/types/page';
import { type PageElement } from '@editor2/types/pageElements';
import { type Book } from '@editor2/types/book';
import { collapseIcon, collapseIconRotate } from '@editor2/styles/icons';
import AttributesDiff from './AttributeChanges';

interface Props {
	index: number;
	initialIndex: number;
	initial: Book | Chapter | PageGroup | Page | PageElement;
	attributeChanges: any;
	title: string;
	parentName?: string;
	styles?: string;
	isNewElement?: boolean;
}

const ChangesDiff: FC<Props> = (props) => {
	const {
		index,
		initialIndex,
		initial,
		attributeChanges,
		title,
		parentName,
		styles,
		isNewElement
	} = props;

	const [showChanges, setShowChanges] = useState(true);

	const isNew = isNewElement || !!attributeChanges.family_id;
	const isModified = !isNew && Object.keys(attributeChanges).length > 0;

	const isPositionChanged = initialIndex >= 0 && index !== initialIndex;
	const isMovedFrom = initialIndex === -1 && !isNew;

	return (
		<div className={chapterChangesStyle}>
			<div className={`${headerStyle} ${styles}`}>
				<span className="title">{title}</span>

				{isNew && <NewBadge />}

				{isMovedFrom && <Badge variant="primary">moved from {parentName}</Badge>}

				{isPositionChanged && (
					<Badge variant="info">
						{initialIndex + 1} <BsArrowRight /> {index + 1}
					</Badge>
				)}

				{(isNew || isModified) && (
					<BsCaretDownFill
						className={`caretDownIcon ${showChanges ? collapseIcon : collapseIconRotate}`}
						onClick={() => setShowChanges(!showChanges)}
					/>
				)}
			</div>

			{showChanges &&
				isNew &&
				Object.keys(attributeChanges).map((attribute, i) => {
					const newValue =
						typeof attributeChanges[attribute] === 'string'
							? attributeChanges[attribute]
							: JSON.stringify(attributeChanges[attribute]);

					return (
						<AttributesDiff
							attributeName={attribute}
							oldValue=""
							newValue={newValue}
							isNew={isNew}
							key={i}
						/>
					);
				})}

			{showChanges &&
				isModified &&
				Object.keys(attributeChanges).map((attribute, i) => {
					const oldValue =
						typeof initial[attribute] === 'string'
							? initial[attribute]
							: JSON.stringify(initial[attribute]);
					const newValue =
						typeof attributeChanges[attribute] === 'string'
							? attributeChanges[attribute]
							: JSON.stringify(attributeChanges[attribute]);

					return (
						<AttributesDiff
							attributeName={attribute}
							oldValue={oldValue}
							newValue={newValue}
							isNew={isNew}
							key={i}
						/>
					);
				})}
		</div>
	);
};

export default ChangesDiff;
